export default "__VITE_PUBLIC_ASSET__35433b60__"